import { buttonVariants } from '@zealot/ui/components/button';
import { cn } from '@zealot/ui/lib/utils';
import type { VariantProps } from 'class-variance-authority';
import type * as React from 'react';

type ButtonLinkProps = React.ComponentProps<'a'> &
  VariantProps<typeof buttonVariants> & {
    isExternal?: boolean;
  };

const ButtonLink = ({
  className,
  variant = 'default',
  size = 'default',
  isExternal = false,
  ...props
}: ButtonLinkProps) => {
  return (
    <a
      data-slot="button-link"
      className={cn(buttonVariants({ variant, size, className }))}
      {...(isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
      {...props}
    />
  );
};

export type { ButtonLinkProps };
export { ButtonLink };
